
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchEnrollments } from "@/services/enrollments";
import { useState, useCallback } from "react";
import { devLog } from "@/utils/devLog";

export const useEnrollments = (userId?: string) => {
  const queryClient = useQueryClient();
  
  const {
    data: enrollments,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['enrollments', userId],
    queryFn: () => fetchEnrollments(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Provide a manual refresh function that can be called externally
  const handleRefresh = useCallback(async () => {
    if (userId) {
      devLog("[useEnrollments] Manual refresh triggered", { userId });
      await refetch();
    }
  }, [refetch, userId]);

  return {
    enrollments,
    error,
    isLoading,
    handleRefresh,
  };
};
